module.exports = __webpack_public_path__ + "static/media/map-icon.15e1b203.svg";